import { GetActiveFieldProps } from './document-viewer-content.types'

export const getActiveField = ({ data, activeField }: GetActiveFieldProps) => {
  if (!data) {
    return
  }
  return data.fields.find((field) => field.id === activeField)
}
